import React from 'react';
import { Dialog, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { Trans } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.layout.ReplaceDialog');
export default function ReplaceDialog(props) {
  const {
    show,
    onClose,
    onReplace,
    name
  } = props;
  const onOkay = evt => {
    onClose(evt);
    onReplace(evt);
  };
  return /*#__PURE__*/_jsx(Dialog.Question, {
    show: show,
    title: t('title'),
    okay: t('okay'),
    okayVariant: "primaryDestructive",
    onCancel: onClose,
    onOkay: onOkay,
    children: /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(Trans, {
        i18nKey: "molten.dataViewers.layout.ReplaceDialog.message",
        values: {
          name
        },
        components: {
          b: /*#__PURE__*/_jsx("b", {})
        }
      })
    })
  });
}